import { Col, Row, Spin } from 'antd';
import FeatherIcon from 'feather-icons-react';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
//
import { Main } from '../../styled';
import { getCarAmigoDetail } from '../../../redux/carImport/carAmigo/actionCreator';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { ProductDetailsWrapper } from '../../car/Style';
import Heading from '../../../components/heading/heading';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { Button } from '../../../components/buttons/buttons';
import { getBodyTypeById, getColorById, getFuelById, getGearboxType } from '../../../utils/caramigo';
import { contentAccordingToLang } from '../../../utils/common';

const getStatus = statusObj => {
  if (!statusObj) return '-';
  if (statusObj.end) return 'Finished';
  if (statusObj.init) return 'Started';
};

const AmigoCarDetail = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useState({
    index: 0,
  });
  const { apiLoading, carAmigoDetail } = useSelector(state => {
    return {
      apiLoading: state.carAmigo.apiLoading,
      carAmigoDetail: state.carAmigo.carAmigoDetail,
    };
  });

  useEffect(() => {
    dispatch(getCarAmigoDetail(match.params.id));
  }, [match.params.id]);

  if (apiLoading || !carAmigoDetail) {
    return (
      <div className="spin">
        <Spin />
      </div>
    );
  }
  const mappedBodyType = getBodyTypeById(carAmigoDetail.bodyType);
  const mappedFuel = getFuelById(carAmigoDetail.fuel);
  const mappedGearbox = getGearboxType(carAmigoDetail.gearbox);

  return (
    <>
      <PageHeader
        ghost
        title={
          <span className="text-capitalize">{`${carAmigoDetail.brand} ${carAmigoDetail.model} ${carAmigoDetail.year}`}</span>
        }
        buttons={[
          <Button
            key="1"
            style={{ backgroundColor: 'grey', color: '#fff' }}
            size="default"
            onClick={() => history.push(`/admin/car-import/caramigo`)}
          >
            <FeatherIcon icon="chevron-left" size={16} /> Back to List
          </Button>,
        ]}
      />
      <Main>
        <Cards headless>
          <ProductDetailsWrapper>
            <div className="product-detail-box">
              <Row gutter={30}>
                <Col xs={24} lg={10}>
                  <div className="product-details-box_left pdbl">
                    <figure>
                      <img
                        src={carAmigoDetail.pictures[state.index] || require('../../../static/img/noimage.png')}
                        alt={`${carAmigoDetail.brand}-${carAmigoDetail.model}-${carAmigoDetail.year}`}
                        height={300}
                        style={{ width: '100%', objectFit: 'contain' }}
                      />
                      {carAmigoDetail.pictures && (
                        <div className="pdbl__slider pdbs">
                          <Row gutter={5}>
                            {carAmigoDetail.pictures.map((value, index) => {
                              return (
                                <Col
                                  md={4}
                                  key={index}
                                  onClick={() => setState({ ...state, index })}
                                  style={{ marginBottom: 10 }}
                                >
                                  <div
                                    className="pdbl__image"
                                    key={index}
                                    style={{ aspectRatio: '1/1', cursor: 'pointer' }}
                                  >
                                    <figure style={{ height: '100%' }}>
                                      <img
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        src={value}
                                        alt={`img-${index}`}
                                      />
                                    </figure>
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        </div>
                      )}
                    </figure>
                  </div>
                </Col>
                <Col xs={24} lg={14}>
                  <div className="product-detail-box__right pdbr">
                    <Heading className="pdbr__title text-capitalize" as="h4">
                      {`${carAmigoDetail.brand} ${carAmigoDetail.model} ${carAmigoDetail.year}`}
                    </Heading>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Price:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        € {carAmigoDetail.smaxPrice}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Offered Price:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {carAmigoDetail.offeredPrice ? `€ ${carAmigoDetail.offeredPrice}` : '-'}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Brand:{' '}
                      </span>
                      <span className="pdbr_brand-name text-capitalize" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {carAmigoDetail.brand}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Model:{' '}
                      </span>
                      <span className="pdbr_brand-name text-capitalize" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {carAmigoDetail.model}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Fuel:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {mappedFuel?.details ? contentAccordingToLang(mappedFuel.details)?.fuel_name || '-' : '-'}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        KM Driven:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {carAmigoDetail.km} KM
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        No of Seats:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {carAmigoDetail.numberOfSeats}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Color:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {getColorById(carAmigoDetail.color) || '-'}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Power:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {carAmigoDetail.power}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Body Type:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {mappedBodyType?.details ? contentAccordingToLang(mappedBodyType.details)?.name || '-' : '-'}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Seller Type:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {carAmigoDetail.sellerType}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Gearbox:{' '}
                      </span>
                      <span className="pdbr_brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {mappedGearbox?.details ? contentAccordingToLang(mappedGearbox.details)?.name || '-' : '-'}
                      </span>
                    </p>

                    {/* Vehicle Status */}
                    <Heading className="pdbr__title" as="h4" style={{ marginTop: '10px' }}>
                      Vehicle Status
                    </Heading>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Car Checking :
                      </span>
                      <span className="pdbr__brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {getStatus(carAmigoDetail.vehicle?.carChecking)}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Purchase Order :
                      </span>
                      <span className="pdbr__brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {getStatus(carAmigoDetail.vehicle?.purchaseOrder)}
                      </span>
                    </p>
                    <p
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: '-10px',
                      }}
                    >
                      <span className="pdbr__brand-text" style={{ flex: 2, paddingTop: '10px' }}>
                        Payment :
                      </span>
                      <span className="pdbr__brand-name" style={{ flex: 1, alignItems: 'flex-start' }}>
                        {getStatus(carAmigoDetail.vehicle?.pay)}
                      </span>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </ProductDetailsWrapper>
        </Cards>
      </Main>
    </>
  );
};

export default AmigoCarDetail;
